/* Copyright Verge Technologies 2018
 * @file article.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Article page
 */

// Modules
import React from 'react';
import { Link } from 'react-router-dom';
import { Query } from 'react-apollo';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { POPULAR_ARTICLES_QUERY } from '../../graphql';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';
import Article from '../../components/Article/article';

const ArticlePage = (props) => {
  return (
    <div>
      <Header crumbs={props.crumbs} />
      <Article slug={props.slug} />

      <div className="heading-container">
        <h1>Popular</h1>
        <hr />
      </div>

      <Query query={POPULAR_ARTICLES_QUERY} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100px' }}>
                <PulseLoader loading={loading} color="#004DA9" sizeUnit="px" size={15} />
              </div>
            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          return (
            <div>
              <div className="content-list-container popular-list">
                <ul>
                  {data.getPopularArticles.map((article) => {
                    return (
                      <li key={article.slug}>
                        <div className="image-block">
                          <img src={article.image} alt="article" />
                        </div>
                        <div className="content-block">
                          <h2>{article.title}</h2>
                          <p>
                            {article.article_blurb}
                          </p>
                          <div className="date">{new Date(article.created_at).toDateString()}</div>
                        </div>
                        <div className="control">
                          <Link to={`/articles/${article.slug}`} className="button button-green">
                            Read more
                          </Link>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>

              <div className="icon-pagination">
                <a href={null} className="icon icon-left">
                  <svg
                    width="45px"
                    height="45px"
                    viewBox="0 0 45 45"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g>
                        <g fill="#004DA9">
                          <path
                            d="M22.143,0 C34.3722412,7.48825056e-16 44.286,9.91375878 44.286,22.143 C44.286,34.3722412 34.3722412,44.286 22.143,44.286 C9.91375878,44.286 1.49765011e-15,34.3722412 0,22.143 C-1.49765011e-15,9.91375878 9.91375878,2.24647517e-15 22.143,0 Z"
                            id="Path_327-2"
                          />
                        </g>
                        <path
                          d="M22.143,2.16 C33.1793062,2.16 42.126,11.1066938 42.126,22.143 C42.126,33.1793062 33.1793062,42.126 22.143,42.126 C11.1066938,42.126 2.16,33.1793062 2.16,22.143 C2.16,11.1066938 11.1066938,2.16 22.143,2.16 Z"
                          fill="#EBEBEB"
                        />
                        <rect
                          fill="#004DA9"
                          transform="translate(21.738353, 18.497835) rotate(-45.000000) translate(-21.738353, -18.497835) "
                          x="15.2573532"
                          y="17.1478351"
                          width="12.962"
                          height="2.7"
                        />
                        <rect
                          fill="#004DA9"
                          transform="translate(21.739165, 25.754353) rotate(45.000000) translate(-21.739165, -25.754353) "
                          x="15.2581649"
                          y="24.4043532"
                          width="12.962"
                          height="2.7"
                        />
                      </g>
                    </g>
                  </svg>
                </a>
                <a href={null} className="icon icon-right">
                  <svg
                    width="45px"
                    height="45px"
                    viewBox="0 0 45 45"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g transform="translate(22.500000, 22.500000) scale(-1, 1) translate(-22.500000, -22.500000) ">
                        <g fill="#004DA9">
                          <path
                            d="M22.143,0 C34.3722412,7.48825056e-16 44.286,9.91375878 44.286,22.143 C44.286,34.3722412 34.3722412,44.286 22.143,44.286 C9.91375878,44.286 1.49765011e-15,34.3722412 0,22.143 C-1.49765011e-15,9.91375878 9.91375878,2.24647517e-15 22.143,0 Z"
                            id="Path_327-2"
                          />
                        </g>
                        <path
                          d="M22.143,2.16 C33.1793062,2.16 42.126,11.1066938 42.126,22.143 C42.126,33.1793062 33.1793062,42.126 22.143,42.126 C11.1066938,42.126 2.16,33.1793062 2.16,22.143 C2.16,11.1066938 11.1066938,2.16 22.143,2.16 Z"
                          fill="#EBEBEB"
                        />
                        <rect
                          fill="#004DA9"
                          transform="translate(21.738353, 18.497835) rotate(-45.000000) translate(-21.738353, -18.497835) "
                          x="15.2573532"
                          y="17.1478351"
                          width="12.962"
                          height="2.7"
                        />
                        <rect
                          fill="#004DA9"
                          transform="translate(21.739165, 25.754353) rotate(45.000000) translate(-21.739165, -25.754353) "
                          x="15.2581649"
                          y="24.4043532"
                          width="12.962"
                          height="2.7"
                        />
                      </g>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          );
        }}
      </Query>
      <Footer />
    </div>
  );
};

export default ArticlePage;



// WEBPACK FOOTER //
// ./src/pages/article/article.page.js